import { useState, useEffect } from 'react';
import { Logo, FormRow } from '../components';
import Wrapper from '../assets/wrappers/RegisterAndLoginPage';
import { Link, Form, redirect, useLoaderData } from 'react-router-dom';
import { toast } from 'react-toastify';
import { customFetch } from '../utils/custom-fetch.js';

export const loader = async ({ params }) => {
  try {
    const data = await customFetch.post(`/users/verify-email`, {
      _id: params._id,
    });
    return data.data;
  } catch (error) {
    return redirect('/dashboard/all-buildings');
  }
};

const VerifyEmail = () => {
  const {email} = useLoaderData();

  const [verificationCode, setVerificationCode] = useState('');
  const [mail, setEmail] = useState(email);
  const [timer, setTimer] = useState(120);

  // useEffect(() => {
  //   let interval;
  //   if (timer > 0) {
  //     interval = setInterval(() => {
  //       setTimer((prev) => prev - 1);
  //     }, 1000);
  //   }
  //   return () => clearInterval(interval);
  // }, [timer]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData);

    try {
      await customFetch.post('/users/check-verification-code', {
        email: data.email,
        code: data.verificationCode
      });
      toast.success('האימות הצליח');
      window.location.href = '/dashboard';
    } catch (error) {
      toast.error(error.response?.data?.msg || 'האימות נכשל');
    }
  };

  const handleResendCode = () => {
    setTimer(120);
  };

  return (
    <Wrapper>
      <Form className='form' method='post' onSubmit={handleSubmit}>
        <Logo />
        <h5 className='form-title'>אמת כתובת דואר אלקטרוני</h5>
        <div className='form-center'>
          <FormRow
            type='text'
            name='verificationCode'
            value={verificationCode}
            handleChange={(e) => setVerificationCode(e.target.value)}
            labelText='קוד אימות'
          />
          <button
            type='submit'
            className='btn btn-block'
            disabled={verificationCode.length !== 6}
          >
            אמת
          </button>
          <button
            type='button'
            className='btn btn-block btn-resend'
            onClick={handleResendCode}
            disabled={timer > 0}
          >
            שלח שוב ({timer})
          </button>
          <p>
            <Link to='/login' className='member-btn'>
              חזרה לכניסה
            </Link>
          </p>
        </div>
      </Form>
    </Wrapper>
  );
};

export default VerifyEmail;
